var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserEmailRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_email"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427320717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.42944 1.33336H29.2247L16.345 14.1953L3.42944 1.33336Z",
    stroke: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.0667 16.6362L31.4861 3.2721V22.2222C31.4861 22.6053 31.3339 22.9727 31.063 23.2436C30.7922 23.5145 30.4248 23.6666 30.0417 23.6666H2.81944C2.43635 23.6666 2.06895 23.5145 1.79807 23.2436C1.52718 22.9727 1.375 22.6053 1.375 22.2222V3.42851L14.6192 16.636L14.6197 16.6365C15.0777 17.0918 15.6973 17.3473 16.3431 17.3473C16.9888 17.3473 17.6084 17.0918 18.0664 16.6365L18.0667 16.6362ZM4.15139 22.7222H4.35729L4.50348 22.5772L11.591 15.548L11.9475 15.1945L11.5924 14.8395L10.2216 13.4686L9.86952 13.1165L9.51597 13.4672L2.44791 20.4769L2.3 20.6236V20.8319V22.2222V22.7222H2.8H4.15139ZM30.0222 22.7222H30.5257L30.5222 22.2187L30.5125 20.8284L30.511 20.6222L30.3646 20.4769L23.2965 13.4672L22.943 13.1165L22.5909 13.4686L21.2201 14.8395L20.865 15.1945L21.2215 15.548L28.309 22.5772L28.4552 22.7222H28.6611H30.0222Z",
    stroke: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEmailRed);
export default __webpack_public_path__ + "static/media/user_email_red.d1dc3e54942410d88d4ace72f0f55c70.svg";
export { ForwardRef as ReactComponent };